<template>
    <ies-form-field :field="field">
        <div class="d-flex flex-column">
            <input type="hidden" :name="field.fieldName" :value="field.value">

            <v-radio-group
                v-model="status"
                row
                autocomplete>
                <v-radio label="Offline"		:value="0"></v-radio>
                <v-radio label="Previewable"	:value="2"></v-radio>
                <v-radio label="Online"			:value="1"></v-radio>
            </v-radio-group>
        </div>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-input-display-status-type',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
			status: parseInt(this.field.value),
        }
    },

	watch: {
		status: function (newValue) {
			this.field.value = newValue;
		}
	}	
}
</script>



